/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'Group',dictionary:{"de":{"references":{"crudOptionPermissions":"Berechtigungen"},"general":{"name":"Name","description":"Beschreibung"},"permissions":{"frontendRoles":"Frontend Rollen","crudOptionPermissions":"Datenbankrechte"}},"en":{"references":{"crudOptionPermissions":"Permissions"},"general":{"name":"Name","description":"Description"},"permissions":{"frontendRoles":"Frontend Roles","crudOptionPermissions":"Database Permissionss"}}}})
import { Login } from './Login';

export class Group extends _BaseModel {
	
	static toString() {
		return 'Group'
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Group.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Group', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Group.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Group', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.Group.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'Group', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Group', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'Group', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.Group.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'Group', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Group'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Group) || _BaseModel.t('rules.reference', {modelName:'Group', path:'meta.currentDocument'}) ],
				model: Group,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Group', path:'meta.revisions'}) ],
				model: Group,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			general: 				{
					
	name:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Group.general.name'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Group', path:'general.name'}) ],
},
    
	},
	
					
	description:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Group.general.description'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'Group', path:'general.description'}) ],
},
    
	},
	
},
			permissions: 				{
					
	frontendRoles:{
		type: 'array',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Group.permissions.frontendRoles'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'Group', path:'permissions.frontendRoles'}) ],
},
    
	},
	
					
	crudOptionPermissions:{
		type: 'object',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Group.permissions.crudOptionPermissions'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'object') || _BaseModel.t('rules.type.object', {modelName:'Group', path:'permissions.crudOptionPermissions'}) ],
},
    
	},
	
},
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.Group._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, general={}, permissions={}, _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.general=GeneralClass.create(general);
		this.permissions=PermissionsClass.create(permissions);
		this._id=_id;
	}

	static create(data) {
		return new Group(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof Group || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : Group.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof Group ? item : Group.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class GeneralClass {
	constructor({name='', description='', }={}){
		this.name=name;
		this.description=description;
	}

	static create(data) {
		return new GeneralClass(data);
	}
}

class PermissionsClass {
	constructor({frontendRoles=[], crudOptionPermissions={"Absence":{"none":{"read":false,"write":false}},"Activity":{"none":{"read":false,"write":false}},"Customer":{"none":{"read":false,"write":false}},"Login":{"none":{"read":false,"write":false}},"Organization":{"none":{"read":false,"write":false}},"Person":{"none":{"read":false,"write":false}},"Project":{"none":{"read":false,"write":false}},"ProjectTimeReport":{"none":{"read":false,"write":false}},"Worker":{"none":{"read":false,"write":false}},"WorkerTimeReport":{"none":{"read":false,"write":false}},"WorkRecord":{"none":{"read":false,"write":false}},"Group":{"none":{"read":false,"write":false}},"CrudOptionPermission":{"none":{"read":false,"write":false}},"AbsenceType":{"none":{"read":false,"write":false}},"ActivityType":{"none":{"read":false,"write":false}},"ActivityCategory":{"none":{"read":false,"write":false}},"RideRecord":{"none":{"read":false,"write":false}},"Weather":{"none":{"read":false,"write":false}},"WeatherRecord":{"none":{"read":false,"write":false}},"WorkRecordDispute":{"none":{"read":false,"write":false}},"ProjectType":{"none":{"read":false,"write":false}},"CustomerType":{"none":{"read":false,"write":false}},"ProjectStatus":{"none":{"read":false,"write":false}},"CustomerStatus":{"none":{"read":false,"write":false}},"Gender":{"none":{"read":false,"write":false}},"ProjectCategory":{"none":{"read":false,"write":false}},"WorkTime":{"none":{"read":false,"write":false}},"WorkerContractualRelationship":{"none":{"read":false,"write":false}},"WorkerDivision":{"none":{"read":false,"write":false}},"WorkerOperationArea":{"none":{"read":false,"write":false}},"DrivingLicense":{"none":{"read":false,"write":false}},"WorkerProfession":{"none":{"read":false,"write":false}},"WorkerQualification":{"none":{"read":false,"write":false}},"WorkerStatus":{"none":{"read":false,"write":false}},"WorkerSkillLevel":{"none":{"read":false,"write":false}},"WorkerType":{"none":{"read":false,"write":false}},"LessonsLearned":{"none":{"read":false,"write":false}}}, }={}){
		this.frontendRoles=frontendRoles;
		this.crudOptionPermissions=crudOptionPermissions;
	}

	static create(data) {
		return new PermissionsClass(data);
	}
}
